module.exports = __webpack_public_path__ + "packs/media/images/climber_man-a9d389492a04630fb6a7a399ad85a76d.jpg";